module.exports = __webpack_public_path__ + "img/blueWallet.f96174a7.svg";